import React from 'react'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload} from 'types'
import {Paragraph} from 'common/components'

export interface GiftShopMessageRoomContentItemNotificationAcceptInvitationAdminProps {
  payload: FirebaseMessageRoomItemPayload['notification_accept_invitation_admin']
}

export default function GiftShopMessageRoomContentItemNotificationAcceptInvitationAdmin({
  payload: {host_tag, username},
}: GiftShopMessageRoomContentItemNotificationAcceptInvitationAdminProps) {
  const {translate} = useTranslation()

  return (
    <>
      <Paragraph fontSize="m">
        {translate('messages:hiUsername', {username})}
      </Paragraph>
      <br />
      <Paragraph fontSize="m">
        {translate('messages:notificationAdminInvitationAccepted', {host_tag})}
      </Paragraph>
    </>
  )
}
